import React from 'react'
import PropTypes from 'prop-types'

import { Form, Modal } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './CreateGroupModalContainer'
import Enhancer from './CreateGroupModalEnhancer'

import Button from 'Components/StandardButton'
import ErrorMessage from 'Components/ErrorMessage'

import icons from 'Global/icons'

import * as styles from './styles'

const CreateGroupModal = props => {
  const { close, handleCreate, handleNameChanged, hasError, isPending, name } = props

  return (
    <Modal onClose={close} open={true}>
      <Modal.Header>Create Group</Modal.Header>

      <Modal.Content>
        {hasError && <ErrorMessage message="This wasn't supposed to happen. Please try again. Duplicate group names are forbidden." />}

        <Form onSubmit={handleCreate} size="tiny">
          <Form.Field>
            <Form.Input
              // error={errors.reason}
              label="Group Name"
              name="name"
              onChange={handleNameChanged}
              placeholder="Group Name"
              style={styles.name}
              type="text"
              value={name}
            />
          </Form.Field>

          <div style={styles.button}>
            <Button color="black" content="Create" disabled={isPending} error={hasError} icon={icons['create']} pending={isPending} />
          </div>
        </Form>
      </Modal.Content>

      <Modal.Actions>
        <Button content="Close" icon={icons['close']} onClick={close} />
      </Modal.Actions>
    </Modal>
  )
}

CreateGroupModal.propTypes = {
  close: PropTypes.func.isRequired,
  handleCreate: PropTypes.func.isRequired,
  handleNameChanged: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(CreateGroupModal)
// export default CreateGroupModal
